export function JournalEntriesTopbar() {
  return <></>;
}
